import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AuthService } from '@klickdata/core/auth';
import { AppScope } from '@klickdata/core/resource';
import { Section, SectionService } from '@klickdata/core/section';
import { User } from '@klickdata/core/user';
import { BehaviorSubject, map, Observable, switchMap, tap } from 'rxjs';

@Component({
    selector: 'app-guest-mode-sections',
    templateUrl: './guest-mode-sections.component.html',
    styleUrls: ['./guest-mode-sections.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuestModeSectionsComponent implements OnInit {
    AppScope = AppScope;
    public user$: Observable<User>;
    public scopesExpansions: {};
    @Input() selectedView = 'grid';
    public nextSectionsPageSub: BehaviorSubject<number> = new BehaviorSubject<number>(0);
    public sectionsHolder: Section[] = [];
    public currentSectionsPage = 0;
    public totalPages: number;
    public sections$: Observable<Section[]>;
    public emptySections = [];
    throttle = 300;
    scrollDistance = 2;
    scrollUpDistance = 2;

    constructor(
        protected auth: AuthService,
        protected sectionService: SectionService,
        protected cdr: ChangeDetectorRef
    ) {
        this.user$ = this.auth.getUser();
    }
    ngOnInit(): void {
        // header = 108;
        // other = 100;
        // section = 300;
        const initalSectionsCount = Math.round((window.innerHeight - (108 + 100)) / 300 + 1);
        this.selectedView = this.selectedView == 'section' ? 'grid' : this.selectedView;
        this.sections$ = this.nextSectionsPageSub.asObservable().pipe(
            switchMap((page) =>
                this.sectionService.getGuestSections({
                    limit: initalSectionsCount,
                    page: page,
                })
            ),
            map((response) => {
                this.totalPages = response.paginator.total_pages;
                return (this.sectionsHolder = [...this.sectionsHolder, ...response.data]);
            }),
            tap((sections) => {
                this.scopesExpansions = sections.reduce((acc, item) => {
                    acc[item.id] = true;
                    return acc;
                }, {});
            })
        );
    }
    public requestNextSectionsPage() {
        if (this.totalPages - 1 > this.currentSectionsPage) {
            this.currentSectionsPage++;
            this.nextSectionsPageSub.next(this.currentSectionsPage);
        }
    }
    public onEmptySections(secId: number) {
        this.emptySections.push(secId);
        this.cdr.detectChanges();
    }
}
